import { action } from 'mobx'

import { client } from 'lib/apollo-client'
import { authService } from 'services/auth'
import datadog from 'utils/datadog'
import { intercomDisable } from 'utils/gtm'

import localStorage from '../utils/localStorageUtils'

class AuthenticationStore {
  @action async logout() {
    // Clear the host Apollo cache before tearing down the session. Redundant in the happy path
    // (keycloak.logout() triggers a full-page redirect that drops the cache anyway), but protects
    // any future non-navigating logout flow (session timeout, account switch) from leaking the
    // previous user's data. Best-effort: if clearStore rejects (e.g. an in-flight query errors
    // out) swallow it so the localStorage cleanup, GTM event, and Keycloak logout redirect below
    // still run — the user is leaving either way.
    await client.clearStore().catch(error => {
      datadog.dispatchGenericErrorLog({
        log: {
          from: 'AuthenticationStore.logout',
          name: 'apollo_clear_store_failed',
          message: 'client.clearStore() rejected during logout',
        },
        error: error instanceof Error ? error : new Error('non-Error rejection'),
      })
    })
    localStorage.delete('panelId')
    localStorage.delete('id')
    intercomDisable()
    // NOTE: user-scoped MobX stores (UserStore/PanelStore/FilterStore) are reset by the full-page
    // reload that authService.logout() triggers. Add explicit store resets here if a non-navigating
    // logout flow is ever introduced (no reset seam exists on those stores today).
    await authService.logout()
  }
}

export default new AuthenticationStore()
